import { render, staticRenderFns } from "./objectFurnitureReportDialog.vue?vue&type=template&id=0d28e815&"
import script from "./objectFurnitureReportDialog.vue?vue&type=script&lang=js&"
export * from "./objectFurnitureReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports